import { BUSCAR_CONFIGURACAO_PONTO_EMPRESA, LIMPAR_CONFIGURACAO_PONTO_EMPRESA } from '../../actions/types'

const initialState = null
const estadoInicial = {
    id: null,
    empresa: {},
    quantidadePonto: null,
    habilitadoGeracaoPontos: null,
    habilitadoConsumoPontos: null,
    peso: null
}

export default function reducerAdesaoPontoEmpresa (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_CONFIGURACAO_PONTO_EMPRESA: {
      if (action.payload.data == null) {
        return estadoInicial;
      }

      return action.payload.data;
    }

    case LIMPAR_CONFIGURACAO_PONTO_EMPRESA:
      return estadoInicial;

    default: {
      return state
    }
  }
}